// Audience landings, shared by the cross-link cards and the teaser strip under each landing's first screen.
export const audiences = [
  { name: 'friends', image: '/assets/company/crab-party.webp', alt: 'Компания друзей и гигантские крабы на вечеринке', label: 'Для компании', title: 'Вечеринка, созвон или корпоратив', text: 'За одним столом или по ссылке из разных городов →' },
  { name: 'kids', image: '/assets/kids/cupcake-original.webp', alt: 'Кекс на доске для сёрфинга, вокруг единороги и радуга', label: 'Для детей и родителей', title: 'Фантазия, которую видно', text: 'Развивает воображение и речь — и просто весело вместе →' },
  { name: 'solo', image: '/assets/company/lava-original.webp', alt: 'Металлический шар на раскалённой лаве', label: 'Один на один с ИИ', title: 'Соперник, который всегда готов', text: 'Начните матч сразу — без ожидания друзей →' },
]

// Teaser wording depends on the page it is shown on: teasers[current page][linked audience].
export const teasers = {
  friends: {
    solo: { question: 'Пока нет компании?', answer: 'Сыграйте один на один с ИИ' },
    kids: { question: 'Играете с детьми?', answer: 'Есть версия для всей семьи' },
  },
  kids: {
    solo: { question: 'Ребёнок уснул?', answer: 'Сразитесь с ИИ сами' },
    friends: { question: 'Собираетесь со взрослыми?', answer: 'Игра для компании друзей' },
  },
  solo: {
    friends: { question: 'Друзья освободились?', answer: 'Играйте всей компанией' },
    kids: { question: 'Рядом ребёнок?', answer: 'Придумывайте сцены вместе' },
  },
}
